import script from "./GameManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameManager.vue?vue&type=script&setup=true&lang=ts"

import "./GameManager.vue?vue&type=style&index=0&id=2d459145&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d459145"]])

export default __exports__